import axios from '@jumbo/utils/axiosHelper';
import url from '../../@jumbo/constants/UrlConstant';
import { fetchError, fetchStart, fetchSuccess } from '../../redux/actions';
import {
  getHomeList,
  setActiveHomePagination,
  setHomePagination,
  setKeywordHome,
  setSelectedFile,
} from '../../redux/actions';
import _ from 'lodash';

const HomeLoad = {
  getList: () => {
    return (dispatch, getState) => {
      const { activePaginate } = getState().home;
      const {
        authUser: { role },
      } = getState().auth;
      dispatch(fetchStart());
      let endpoin;
      if (role === 'personal') {
        endpoin = `${url.personal.list}?page=${activePaginate}`;
      } else if (role === 'instansi') {
        endpoin = `${url.instansi.list}?page=${activePaginate}`;
      } else {
        endpoin = `${url.dokter.list}?page=${activePaginate}`;
      }

      axios
        .get(endpoin)
        .then(({ data, status }) => {
          if (status === 200) {
            if (data.success) {
              dispatch(fetchSuccess());
              let key;
              if (role === 'personal') {
                key = 'personalhome';
              } else if (role === 'instansi') {
                key = 'instansihome';
              } else {
                key = 'doktorhome';
              }
              const result = data[key].data;
              dispatch(getHomeList(result));
              dispatch(
                setHomePagination({
                  current_page: data[key].current_page,
                  per_page: data[key].per_page,
                  total: data[key].total,
                  last_page: data[key].last_page,
                  from: data[key].from,
                }),
              );
            }
          } else {
            dispatch(fetchError(data.message));
          }
        })
        .catch(function(error) {
          dispatch(fetchError(error.message));
        });
    };
  },
  getFile: id => {
    return (dispatch, getState) => {
      dispatch(fetchStart());
      const {
        authUser: { role },
      } = getState().auth;
      let endpoin;
      if (role === 'personal') {
        endpoin = `${url.personal.getFile}/${id}`;
      } else if (role === 'instansi') {
        endpoin = `${url.instansi.getFile}/${id}`;
      } else {
        endpoin = `${url.dokter.getFile}/${id}`;
      }
      axios
        .get(endpoin)
        .then(({ data, status }) => {
          if (status === 200) {
            if (data.success) {
              dispatch(fetchSuccess());
              const result = data.file;
              if (Array.isArray(result) && result.length === 0) {
                dispatch(setSelectedFile(result));
              } else {
                dispatch(setSelectedFile(result.nama_file));
              }
            }
          } else {
            dispatch(fetchError(data.message));
          }
        })
        .catch(function(error) {
          dispatch(fetchError(error.message));
        });
    };
  },
  getHasilBaru: () => {
    return (dispatch, getState) => {
      const { activePaginate, keyword } = getState().home;
      const {
        authUser: { role },
      } = getState().auth;
      dispatch(fetchStart());
      let endpoin;
      if (role === 'personal') {
        endpoin = `${url.personal.hasil}?page=${activePaginate}&keyword=${keyword}`;
      } else if (role === 'instansi') {
        endpoin = `${url.instansi.hasil}?page=${activePaginate}&keyword=${keyword}`;
      } else {
        endpoin = `${url.dokter.hasil}?page=${activePaginate}&keyword=${keyword}`;
      }

      axios
        .get(endpoin)
        .then(({ data, status }) => {
          if (status === 200) {
            if (data.success) {
              dispatch(fetchSuccess());
              let key;
              if (role === 'personal') {
                key = 'personalHasil';
              } else if (role === 'instansi') {
                key = 'instansiHasil';
              } else {
                key = 'doktormHasil';
              }
              const result = data[key].data;
              dispatch(getHomeList(result));
              dispatch(
                setHomePagination({
                  current_page: data[key].current_page,
                  per_page: data[key].per_page,
                  total: data[key].total,
                  last_page: data[key].last_page,
                  from: data[key].from,
                }),
              );
            }
          } else {
            dispatch(fetchError(data.message));
          }
        })
        .catch(function(error) {
          dispatch(fetchError(error.message));
        });
    };
  },
};

export default HomeLoad;
